import { render, staticRenderFns } from "./PoiManagementPage.vue?vue&type=template&id=e53b1ca0"
import script from "./PoiManagementPage.vue?vue&type=script&lang=js"
export * from "./PoiManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports